import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import { TEASER_SLIDER_CONTAINER_CONVERTER_TOKEN, TeaserSliderContainerConverter } from './teaser-slider-container.component.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        teaserSliderContainerFeature: {
          module: () => import('./teaser-slider-container.module').then((m) => m.TeaserSliderContainerModule),
          cmsComponents: ['teaser_slider_container'],
        },
      }
    }),
    {
      provide: TEASER_SLIDER_CONTAINER_CONVERTER_TOKEN,
      useClass: TeaserSliderContainerConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        teaser_slider_container: TEASER_SLIDER_CONTAINER_CONVERTER_TOKEN
      },
      multi: true
    }
  ]
})
export class TeaserSliderContainerFeatureModule {}
